<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#f3c7a2"
    :border="true"
    inactive-color="#979799"
    z-index="999"
    class="tabber_view"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t('导航.首页') }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/home-active.png' : '/img/footer/home.png'"
          :alt="$t('导航.首页')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/footer/home-active.png' : '/img/footer/home.png'"
          :alt="$t('导航.首页')"
          class="首页"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>
    <!-- 影院 -->
    <van-tabbar-item to="/Choose">
      <span>{{ $t('导航.选妃') }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/choose-active.png' : '/img/footer/choose.png'"
          :alt="$t('导航.选妃')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/footer/choose-active.png' : '/img/footer/choose.png'"
          :alt="$t('导航.选妃')"
          class="影院"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item>

    <!-- 会员等级 -->
    <van-tabbar-item to="/start">
      <span>{{ $t('导航.认证') }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/feed-active.png' : '/img/footer/feed.png'"
          :alt="$t('导航.认证')"
          v-show="show !== 2"
        />
        <img
         :src="props.active ? '/img/footer/feed-active.png' : '/img/footer/feed.png'"
          :alt="$t('导航.认证')"
          class="认证"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Video">
      <span>{{ $t('导航.影院') }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/video-active.png' : '/img/footer/video.png'"
          :alt="$t('导航.影院')"
          v-show="show !== 3"
        />
        <img
         :src="props.active ? '/img/footer/video-active.png' : '/img/footer/video.png'"
          :alt="$t('导航.影院')"
          class="投票"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item>
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t('导航.个人') }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/mine-active.png' : '/img/footer/mine.png'"
          :alt="$t('导航.个人')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/footer/mine-active.png' : '/img/footer/mine.png'"
          :alt="$t('导航.个人')"
          class="个人"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "choose") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "membership" || to.name == "start") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "video") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "choose") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "membership" || this.$route.name == "start") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;
.tabber_view{
  background-color: #1f1c1f;
}
.van-tabbar {
  height: @tabbar-height;
}
.van-tabbar-item__icon img {
  height: 7vw;
}
.van-tabbar-item {
  font-size: 26px;
}
.tui {
  width: 4rem;
  height: 4rem!important;
  margin-top: -7.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}
[class*="van-hairline"]::after {
  border: none !important;
}
::v-deep .van-tabbar-item--active{
  background-color: transparent;
}
</style>
